module.exports = __webpack_public_path__ + "static/js/logic.699d8b16.chunk.worker.js"